import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles({
  allContainer: {
    width: 667,
    height: 508,
    margin: "0 auto",
    paddingTop: 50,
  },
  title: {
    fontSize: 30,
    color: "#b00020",
  },
  paper: {
    margin: 0,
    width: 667,
    height: 508,
    maxWidth: 667,
    maxHeight: 508,
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    alignItems: "center",
  },

  dialogAction: { padding: 0 },
});

const ErrorDialog = ({
  open,
  code,
  errorTitle = "Error",
  errorMessage = "Please try again later",
  onClose,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={open}
      className={classes.allContainer}
      onClose={onClose}
    >
      <DialogTitle id="customized-dialog-title">
        <Typography align="center" classes={{ root: classes.title }}>
          {errorTitle}
        </Typography>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        {code}
      </DialogContent>
      <DialogContent classes={{ root: classes.dialogContent }}>
        {errorMessage}
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Button
          onClick={onClose}
          color="primary"
          fullWidth
          variant="contained"
          classes={{ contained: classes.button }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
